import styled from 'styled-components';

const SectionLoginPage = styled.section``;

export default SectionLoginPage;
